const randomize = list => (list || []).map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

export const ArrayUtils = {
    randomize,
};